import * as React from 'react';

import withSequenceState from 'components/hoc/withSequenceState';
import Sequences from 'defs/sequences';

import Link from 'components/atoms/Link';
import ButtonBar from 'components/molecules/ButtonBar';
import CardLike from 'components/molecules/Card/elements/Like';
import ContentVideo from 'components/molecules/ContentVideo';
import LinkList from 'components/molecules/LinkList';
import Rich from 'components/molecules/Rich';
import ContentImageSlider from 'components/molecules/Slider/ContentImageSlider';

import { warn } from 'helper/debug';
import i18n from 'helper/i18n';

import { LinkProps } from 'components/atoms/Link';
import { WithFavoritePropsType } from 'components/hoc/Cards/withFavorite';
import { WithHandleCompletePropsType } from 'components/hoc/Cards/withHandleComplete';
import { ContentImageProps } from 'components/molecules/ContentImage';
import { ContentVideoProps } from 'components/molecules/ContentVideo';

export type CardDetailTaskProps = {
	id: number;
	title: string;
	richText: string;
	state: string;
	link?: LinkProps;
	isDone: boolean;
	isCheckable: boolean;
	images?: ContentImageProps[];
	contentVideo?: ContentVideoProps;
	handleCardContentClick: Function;
	handleShowDetailsClick: Function;
	doComplete: Function;
	isSequenceLoading: boolean;
	favorite: boolean;
};

export type CardDetailTaskState = {
	isUpdating: boolean;
};

export class CardDetailTask extends React.Component<
	CardDetailTaskProps & WithHandleCompletePropsType & WithFavoritePropsType
> {
	public static displayName = 'CardDetailTask';

	public handleButtonClicks = (buttonType: string) => {
		if (this.props.isSequenceLoading) {
			return;
		}

		switch (buttonType) {
			case 'completed':
				this.props.onComplete({
					type: 'task',
					onAnimationDone: () => {
						this.props.doComplete(this.props.id);
					},
				});
				break;
			default:
				warn(`Button Action "${buttonType}" not available`);
		}
	};

	public renderButtonBar = () => {
		const { isDone, isCheckable, isSequenceLoading, isUiCompleting } = this.props;
		let cardButtons: any = null;

		if (!isCheckable) {
			return null;
		}

		if (!isDone) {
			cardButtons = {
				buttons: [
					{
						knob: {
							modifier: 'dashed',
							size: 'l',
							icon: 'completed',
						},
					},
				],
			};
		}

		if (cardButtons === null) {
			return null;
		}

		return (
			<div className="m-card__button-bar">
				<ButtonBar
					loading={isUiCompleting}
					disabled={isSequenceLoading}
					handleButtonClicks={this.handleButtonClicks}
					buttons={cardButtons.buttons}
				/>
			</div>
		);
	};

	public render() {
		const {
			id,
			title,
			handleCardContentClick,
			handleShowDetailsClick,
			handleToggleFavorite,
			images,
			contentVideo,
			richText,
			link,
			favorite,
		} = this.props;

		return (
			<div>
				<div className="m-card__content" onClick={handleCardContentClick as any}>
					<div className="m-card__info m-card__info--has-like">
						{title && <h4 className="m-card__info-title">{title}</h4>}
						<CardLike onClick={handleToggleFavorite} liked={favorite} />
					</div>
					<div className="m-card__link js-m-card__link">
						<Link
							onClick={handleShowDetailsClick as any}
							title={i18n('react.impulsCoach.components.cardDetail.task.linkText')}
							modifier="button"
							openInNewWindow={false}
							iconRight={null}
						/>
					</div>
					<div className="m-card__detail">
						{richText && <Rich contents={richText} />}
						<ContentImageSlider id={id} images={images} />
						{contentVideo && <ContentVideo caption={contentVideo.caption} video={contentVideo.video} />}
						{link && <LinkList links={[{ ...link, href: void 0, externalHref: link.href }]} />}
					</div>
					{this.renderButtonBar()}
				</div>
			</div>
		);
	}
}

export default withSequenceState(CardDetailTask, [Sequences.CARD_IS_CHECKING]);
